"use client";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setWishlistItems } from "@/store/wishlist/wishlistSlice";
import { useGetWishlistProductsQuery } from "@/store/wishlist/wishlistApiSlice";

const FetchWishlist = () => {
  const dispatch = useDispatch();
  const { data } = useGetWishlistProductsQuery();
  useEffect(() => {
    if (data && data.length) {
      dispatch(setWishlistItems(data));
    }
  }, [data, dispatch]);
  return null;
};

export default FetchWishlist;
